import { Injectable } from '@angular/core';
import { MenuService } from './menu.service';
import { TokenService } from '../authentication/token.service';
import { UserApiService } from '../authentication/user-api.service';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { MenuDef } from '@core/bootstrap/menu.definition';
import { catchError, switchMap } from 'rxjs/operators';
import { iif, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StartupService {
  constructor(
    private token: TokenService,
    private menu: MenuService,
    private login: UserApiService,
    private permissonsSrv: NgxPermissionsService
    // private rolesSrv: NgxRolesService
  ) {
  }

  /** Load the application only after get the menu or other essential informations such as roles and permissions. */
  load(): Promise<any> {
    return new Promise((resolve) => {
      this.token
        .changed()
        .pipe(
          switchMap(() => iif(() => this.token.valid(), this.login.basicUserInfo(), of({ roles: [] }))),
          catchError(error => throwError(error))
        )
        .subscribe(user => {
          const menuDef = JSON.parse(JSON.stringify(MenuDef));
          this.menu.reset();
          this.menu.addNamespace(menuDef, 'menu');
          this.menu.set(menuDef);

          this.permissonsSrv.loadPermissions(user.roles);

          // Demo purposes only. You can add essential permissions and roles with your own cases.
          // const permissions = ['canAdd', 'canDelete', 'canEdit', 'canRead'];
          // this.permissonsSrv.loadPermissions(permissions);
          // this.rolesSrv.addRoles({
          //   ROLE_ADMIN: permissions,
          //   ROLE_USER: permissions
          // });

          // Tips: Alternative you can add permissions with role at the same time.
          // this.rolesSrv.addRolesWithPermissions({ ADMIN: permissions });

          resolve(null);
        });
    });
  }
}
